/**
 * Shared loader for the cognito-client code-split chunk.
 * Tier 1 removed auth preloads; prerender snapshots can also inject async script tags
 * for the same chunks. A single shared import promise avoids races where Relay calls
 * ApiClient before the module namespace is ready.
 */
type CognitoModule = typeof import("./cognito-client");

let loadPromise: Promise<CognitoModule> | null = null;

export function loadCognitoClientModule(): Promise<CognitoModule> {
  if (!loadPromise) {
    loadPromise = import("./cognito-client").then((mod) => {
      if (!mod?.CognitoClient) {
        loadPromise = null;
        return Promise.reject(new Error("CognitoClient export missing from cognito-client module"));
      }
      return mod;
    });
  }
  return loadPromise;
}
